















import { Vue, Component, Prop } from 'vue-property-decorator'
import { Commune } from '@/orrm/model/commune'
import config from '@/config'

@Component
export default class LayerDataTable extends Vue {
  @Prop({ default: '' })
  data: string

  get structure () {
    return this.data.split('\n').filter((entry: string) => entry.includes('=')).map((entry: string) => {
      const data = entry.split('=')
      const result = {
        key: data[0].trim(),
        value: data.length > 1 ? data[1].trim().replaceAll('\'', '') : ''
      }
      if (result.key.startsWith('geom')) {
        result.value = result.value.substring(0, 240) + '...'
      }

      return result
    })
  }

  isLink (str: string) {
    const regex = /^https?:\/\//
    return regex.test(str)
  }

  async goToFiche (url: string) {
    const codeInsee = this.structure.find(data => data.key === 'code_insee')

    if (codeInsee) {
      const commune = (await Commune.where<Commune>('field_orrm_code_insee', codeInsee.value).first()).getData()
      if (commune?.path.alias) {
        url = `${config.orrm.siteURL}${commune.path.alias}`
      }
    }

    window.open(url, '_blank')
  }
}
